/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getTimezones } from "api/services/common";
import { commonQueryKeys } from "./commonQueryKeys";

export const useGetTimezones = (filters: any, options?: UseQueryOptions) =>
  useQuery({
    queryKey: commonQueryKeys.timezones(filters),
    queryFn: ({ signal }) => getTimezones({ params: filters, signal }).then((res) => res.data),
    ...options,
  });
